import React from "react";
import { Route, Switch } from "react-router-dom";
import DailyMileageTable from "./DailyMileageTable";
import DailyMileageForm from "./DailyMileageForm";
import WriteRoute from "../../shared/components/WriteRoute";

export default () => (
  <Switch>
    <Route exact path="/dailymileage" component={DailyMileageTable} />
    <WriteRoute
      exact
      path="/dailymileage/addnew"
      component={DailyMileageForm}
      redirectTo="/dailymileage"
    />
  </Switch>
);
